import React, { useEffect } from "react";
import { FiCheckCircle } from "react-icons/fi";
import { FaCircleDollarToSlot } from "react-icons/fa6";
import { IoClose } from "react-icons/io5";
import { MdPermIdentity } from "react-icons/md";
import { TbShare3 } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import { API } from "../../constants/api";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { errorMessage } from "../../utils/errorMessage";
import useAuthAxios from "../../utils/baseAxios";

const ClaimModal = ({
  setShowClaimModal,
  onNavigateKyc,
  onOpenSellFlow,
  onOpenRewardsStep,
}: {
  setShowClaimModal: (open: boolean) => void;
  onNavigateKyc?: () => void;
  onOpenSellFlow?: () => void;
  onOpenRewardsStep?: () => void;
}) => {
  const navigate = useNavigate();
  const axiosInstance = useAuthAxios();
  const getSignupStats = async () => {
    const response = await axiosInstance.get(API.getSignupStats);
    return response.data;
  };
  const { data: signupStats, error: error1, isPending } = useQuery({
    queryKey: ["get-signup-stats"],
    queryFn: getSignupStats,
    retry: 1,
  });
  useEffect(() => {
    if (error1) {
      const newError = error1 as any;
      toast.error(errorMessage(newError?.message || newError?.data?.message));
    }
  }, [error1]);

  const {
    kycCompleted,
    madeMinAmountTrade,
    referredUserMadeCryptoTransaction,
  } = signupStats?.data?.status || {};

  const kycDone = Boolean(kycCompleted);
  const tradeDone = Boolean(madeMinAmountTrade);
  const referDone = Boolean(referredUserMadeCryptoTransaction);
  const allComplete = kycDone && tradeDone && referDone;

  const handleStartNow = () => {
    if (allComplete || isPending) return;
    if (!kycDone) {
      if (onNavigateKyc) {
        onNavigateKyc();
      } else {
        setShowClaimModal(false);
        navigate("/kyc-verification");
      }
      return;
    }
    if (!tradeDone) {
      if (onOpenSellFlow) {
        onOpenSellFlow();
      } else {
        setShowClaimModal(false);
        navigate("/dashboard", { state: { openSellFromClaim: true } });
      }
      return;
    }
    if (!referDone) {
      if (onOpenRewardsStep) {
        onOpenRewardsStep();
      } else {
        setShowClaimModal(false);
        navigate("/dashboard", { state: { openRewardsFromClaim: true } });
      }
    }
  };

  return (
    <div className="fixed inset-0  flex font-manrope justify-center items-center pt-16 overflow-auto pb-16 bg-[#00000040]  bg-opacity-45  ">
      <div
        className={`w-11/12 mds:w-8/12 md:w-7/12 bg-[#042741] bg-claimBg bg-no-repeat bg-top bg-[length:100%_70%] rounded-xl mx-auto p-6 lgss:w-2/5 xxl:w-1/3`}
      >
        <div className="w-full flex justify-end gap-6 items-center">
          <button
            type="button"
            onClick={() => {
              setShowClaimModal(false);
            }}
            className="flex items-center gap-2 "
          >
            <IoClose className=" text-[#FFFFFF] text-[18px]" />
          </button>
        </div>
        <div className="w-full mt-4">
          <h4 className="text-[#F1F3F5] text-[40px] font-sora text-center font-semibold">
            {"\u{1F389} Win \u20A65000"}
          </h4>
          <h4 className="text-[#F1F3F5] text-[40px] font-sora text-center font-semibold">
            free Today!
          </h4>
          <div className="w-full mt-16 flex flex-col gap-4 xs:px-4">
            <div className="w-full flex justify-between items-center bg-[white] bg-opacity-5 px-6 gap-2 py-3 rounded-[12px] ">
              <div className="flex justify-start items-center gap-3">
                <MdPermIdentity className="text-[#279DF3] text-[28px]" />
                <h4 className="text-[white] text-[13px] font-semibold">
                  Finish your KYC up to level 1
                </h4>
              </div>
              {kycDone && (
                <FiCheckCircle className="text-[#26A17B] text-[20px]" />
              )}
            </div>
            <div className="w-full flex justify-between items-center bg-[white] bg-opacity-5 px-6 gap-2 py-3 rounded-[12px] ">
              <div className="flex justify-start items-center gap-3">
                <FaCircleDollarToSlot className="text-[#279DF3] text-[24px]" />
                <h4 className="text-[white] text-[13px] font-semibold">
                  Make your first crypto trade of $100
                </h4>
              </div>
              {tradeDone && (
                <FiCheckCircle className="text-[#26A17B] text-[20px]" />
              )}
            </div>
            <div className="w-full flex justify-between items-center bg-[white] bg-opacity-5 px-6 gap-2 py-3 rounded-[12px] ">
              <div className="flex justify-start items-center gap-3">
                <TbShare3 className="text-[#279DF3] text-[28px]" />
                <h4 className="text-[white] text-[13px] font-semibold">
                  Share your referral link and invite a friend to trade
                </h4>
              </div>
              {referDone && (
                <FiCheckCircle className="text-[#26A17B] text-[20px]" />
              )}
            </div>
            <button
              type="button"
              disabled={isPending || allComplete}
              onClick={handleStartNow}
              className={`w-full bg-secondary_button text-gray-50 text-[16px] font-bold mt-4 py-4 rounded-[10px] ${
                isPending || allComplete
                  ? "opacity-50 cursor-not-allowed"
                  : ""
              }`}
            >
              {allComplete
                ? "All steps completed"
                : isPending
                ? "Loading…"
                : `Start Now for \u20A65000`}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClaimModal;
